import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";

export const About = () => {
  const { t } = useLang();
  if (!t) return null;
  const a = t.about;

  return (
    <section id="a-propos" className="bg-creme py-20 md:py-32" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid gap-12 md:grid-cols-2 md:gap-16 items-start">
          {/* Stylized K block */}
          <Reveal>
            <span className="text-xs uppercase tracking-[0.25em] text-rouge font-medium">{a.eyebrow}</span>
            <div className="mt-6 relative rounded-2xl bg-noir text-creme aspect-[4/3] grid place-items-center overflow-hidden grain shadow-2xl shadow-noir/20">
              <span className="font-serif italic text-[10rem] leading-none text-creme select-none">K.</span>
              <div className="absolute bottom-0 left-0 right-0 h-1.5 bg-gradient-to-r from-rouge via-or to-rouge" />
            </div>
          </Reveal>

          <Reveal delay={120}>
            <h2 className="fluid-h2 text-noir">{a.title}</h2>
            <p className="mt-5 text-gris leading-relaxed">{a.intro}</p>

            <ul className="mt-8 space-y-5" data-testid="about-values-list">
              {a.values.map((v, i) => (
                <li key={v.title || i} className="flex gap-4">
                  <span className="mt-1 font-serif text-or text-lg shrink-0">{String(i + 1).padStart(2, "0")}</span>
                  <div>
                    <h3 className="text-lg text-noir font-semibold">{v.title}</h3>
                    <p className="text-sm text-gris mt-1 leading-relaxed">{v.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>

        {/* Approche */}
        <div className="mt-20 md:mt-28">
          <h3 className="font-serif text-2xl md:text-3xl text-noir mb-10">{a.approach_title}</h3>
          <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-4" data-testid="about-approach-steps">
            {a.approach.map((step, i) => (
              <Reveal
                key={step.step || step.title || i}
                delay={i * 90}
                className="relative bg-white rounded-xl border border-ligne p-6 hover:border-or hover:shadow-xl hover:shadow-noir/5 hover:-translate-y-1 transition-[transform,border-color,box-shadow] duration-300"
              >
                <span className="font-serif text-rouge text-3xl">{step.step}</span>
                <h4 className="mt-4 text-lg text-noir font-semibold">{step.title}</h4>
                <p className="mt-2 text-sm text-gris leading-relaxed">{step.desc}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
